document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.block-prefooter').forEach((instance) => {;
        new Swiper(instance.querySelector('.swiper'), {
            slidesPerView: 3,
            spaceBetween: 30,
            navigation: {
                prevEl: instance.closest('.block-prefooter').querySelector('.slider-button__prev'),
                nextEl: instance.closest('.block-prefooter').querySelector('.slider-button__next'),
            },
            breakpoints: {
                575: {
                    slidesPerView: 4,
                },
                992: {
                    slidesPerView: 6,
                },
                1140: {
                    slidesPerView: 8,
                },
            }
        });
    });

});
